import React from 'react';

import { SettingsSuggest } from '@mui/icons-material';
import { Link, Tooltip } from '@mui/material';

type PromoTesterLinkProps = {
  orderId: string;
  codeName?: string;
  voucherId?: string;
  brand?: string;
};

export default function PromoTesterLink({ codeName, orderId, voucherId, brand }: PromoTesterLinkProps) {
  const search = new URLSearchParams({ orderId });
  if (codeName) {
    search.set('codeName', codeName);
  }
  if (voucherId) {
    search.set('voucherId', voucherId);
  }
  if (brand) {
    search.set('brand', brand);
  }
  const title = voucherId
    ? 'Open this order and voucher in the promo tester'
    : 'Simulate this promo event via the promo tester tool';

  return (
    <Tooltip title={title}>
      <Link target="_blank" rel="noopener noreferrer" href={`/marketing/promo-tester?${search.toString()}`}>
        <SettingsSuggest />
      </Link>
    </Tooltip>
  );
}
